var _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 18.5,
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3249 32.5L34.2142 33.3784L35.0819 32.5L34.2142 31.6216L33.3249 32.5ZM7 32.5L6.11068 31.6216L5.24304 32.5L6.11068 33.3784L7 32.5ZM32.4356 31.6216C29.3067 34.7893 24.9647 36.75 20.1624 36.75V39.25C25.6601 39.25 30.635 37.0021 34.2142 33.3784L32.4356 31.6216ZM20.1624 36.75C15.3602 36.75 11.0182 34.7893 7.88932 31.6216L6.11068 33.3784C9.68992 37.0021 14.6648 39.25 20.1624 39.25V36.75ZM7.88932 33.3784C11.0182 30.2107 15.3602 28.25 20.1624 28.25V25.75C14.6648 25.75 9.68992 27.9979 6.11068 31.6216L7.88932 33.3784ZM20.1624 28.25C24.9647 28.25 29.3067 30.2107 32.4356 33.3784L34.2142 31.6216C30.635 27.9979 25.6601 25.75 20.1624 25.75V28.25Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.55,
    cy: 14.95,
    r: 5.55,
    stroke: "white",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.4ad11d7890f472b2f6398876e8b14839.svg";
export { ForwardRef as ReactComponent };